import { createContext, useContext } from 'react';

export const LoginLoaderContext = createContext({
  showLoader: false,
  setShowLoader: (_showLoader: boolean) => {}
});

export const useLoginContext = () => useContext(LoginLoaderContext);
